export default __webpack_public_path__ + "static/media/sts-5.dd458295.png";